import dict from '@/store/dict/maintenanceOrder'

const {
  payStates,
  payChannels,
  orderState,
  businessTypes,
  itemType,
} = dict
export default function () {
  const searchColumn = [
    {
      type: 'customInput',
      label: '父单ID',
      key: 'parentOrderId',
      options: {
        clearable: true,
        customInputPreset: 'A1',
        maxlength: 50,
      },
    },
    {
      type: 'customInput',
      label: '子单ID',
      key: 'orderId',
      options: {
        clearable: true,
        customInputPreset: 'A1',
        maxlength: 50,
      },
    },
    {
      type: 'tel',
      label: '手机号',
      key: 'userNumber',
      options: {
        clearable: true,
        maxlength: 11,
      },
    },
    {
      type: 'select',
      label: '支付状态',
      key: 'payState',
      source: payStates,
      options: {
        clearable: true,
        placeholder: '请选择',
      },
    },
    {
      type: 'select',
      label: '支付方式',
      key: 'payChannel',
      source: payChannels,
      options: {
        clearable: true,
        placeholder: '请选择',
      },
    },
    {
      type: 'select',
      label: '门店名称(ID):',
      key: 'businessId',
      options: {
        clearable: true,
        filterable: true,
      },
      source: [],
      sourceKey: { value: 'businessId', label: 'businessName' },
    },
    {
      type: 'select',
      label: '维保服务商名称(ID)',
      key: 'tenantId',
      options: {
        clearable: true,
        filterable: true,
      },
      source: [],
      sourceKey: { value: 'tenantId', label: 'tenantName' },
    },
    {
      type: 'areaLinkage',
      key: ['provinceCode', 'cityCode', 'countyCode'],
    },
    {
      type: 'input',
      label: '流水号',
      key: 'payTradeId',
      options: {
        clearable: true,
        maxlength: 50,
      },
    },
    {
      type: 'select',
      label: '订单状态',
      key: 'orderState',
      source: orderState,
      options: {
        clearable: true,
        placeholder: '请选择',
      },
    },
    {
      type: 'input',
      label: '商品名称',
      key: 'itemName',
      options: {
        clearable: true,
      },
    },
    {
      type: 'startEnd',
      label: '订单金额',
      key: 'startAmount,endAmount',
      options: {
        clearable: true,
        maxlength: 50,
      },
    },
    {
      type: 'startEnd',
      label: '实付金额',
      key: 'startFactAmount,endFactAmount',
      options: {
        clearable: true,
        maxlength: 50,
      },
    },
    {
      type: 'datePick',
      label: '下单时间',
      key: 'createTime',
      options: {
        clearable: true,
      },
    },
    {
      type: 'datePick',
      label: '支付时间',
      key: 'payTime',
      options: {
        clearable: true,
      },
    },
    {
      type: 'datePick',
      label: '订单完成时间',
      key: 'usedTime',
      options: {
        clearable: true,
      },
    },
  ]

  const tableColumns = [
    {
      name: 'parentOrderId',
      align: 'center',
      columnProps: {
        label: '父单ID',
        prop: 'parentOrderId',
        minWidth: 120,
      },
      render: ({ row }) => {
        return (
          <span class="a-hover-link" onClick={() => this.handleGoToDetail(row)}>{row.parentOrderId}</span>
        )
      },
    },
    {
      name: 'orderId',
      align: 'center',
      columnProps: {
        label: '子单ID',
        prop: 'orderId',
        minWidth: 120,
      },
    },
    {
      name: 'businessType',
      align: 'center',
      columnProps: {
        label: '业务类型',
        prop: 'businessType',
        minWidth: 120,
      },
      render: ({ row }) => {
        return businessTypes[row.businessType] || '--'
      },
    },
    {
      name: 'orderStateName',
      align: 'center',
      columnProps: {
        label: '订单状态',
        prop: 'orderStateName',
        minWidth: 120,
      },
    },
    {
      name: 'payTradeId',
      align: 'center',
      columnProps: {
        label: '流水号',
        prop: 'payTradeId',
        minWidth: 120,
      },
    },
    {
      name: 'userId',
      align: 'center',
      columnProps: {
        label: '用户ID',
        prop: 'userId',
        minWidth: 120,
      },
    },
    {
      name: 'userNumber',
      align: 'center',
      columnProps: {
        label: '手机号',
        prop: 'userNumber',
        minWidth: 120,
      },
    },

    {
      name: 'tenantId',
      align: 'center',
      columnProps: {
        label: '服务商ID',
        prop: 'tenantId',
        minWidth: 120,
      },
    },
    {
      name: 'tenantName',
      align: 'center',
      columnProps: {
        label: '维保服务商名称',
        prop: 'tenantName',
        minWidth: 120,
      },
    },
    {
      name: 'businessId',
      align: 'center',
      columnProps: {
        label: '门店ID',
        prop: 'businessId',
        minWidth: 120,
      },
    },
    {
      name: 'businessName',
      align: 'center',
      columnProps: {
        label: '门店名称',
        prop: 'businessName',
        minWidth: 120,
      },
    },
    {
      name: 'itemType',
      align: 'center',
      columnProps: {
        label: '订单类型',
        prop: 'itemType',
        minWidth: 120,
      },
      render: ({ row }) => {
        return itemType[row.itemType] || '--'
      },
    },

    {
      name: 'itemName',
      align: 'center',
      columnProps: {
        label: '单品名称',
        prop: 'itemName',
        minWidth: 120,
      },
      render: ({ row }) => {
        const sufix = row.cont > 1 ? '等服务' : ''
        return row.itemName + sufix
      },
    },
    {
      name: 'areaName',
      align: 'center',
      columnProps: {
        label: '省市区',
        prop: 'areaName',
        minWidth: 150,
      },
    },

    {
      name: 'payState',
      align: 'center',
      columnProps: {
        label: '支付状态',
        prop: 'payState',
        minWidth: 150,
      },
      render: ({ row }) => {
        return payStates[row.payState] || '--'
      },
    },

    {
      name: 'createTime',
      align: 'center',
      columnProps: {
        label: '下单时间',
        prop: 'createTime',
        minWidth: 150,
      },
    },

    {
      name: 'payTime',
      align: 'center',
      columnProps: {
        label: '支付时间',
        prop: 'payTime',
        minWidth: 150,
      },
    },
    {
      name: 'usedTime',
      align: 'center',
      columnProps: {
        label: '完成时间',
        prop: 'usedTime',
        minWidth: 150,
      },
    },

    {
      name: 'payChannelName',
      align: 'center',
      columnProps: {
        label: '支付方式',
        prop: 'payChannelName',
        minWidth: 150,
      },
    },

    {
      name: 'amount',
      align: 'center',
      columnProps: {
        label: '订单优惠前金额',
        prop: 'amount',
        minWidth: 150,
      },
    },

    {
      name: 'factAmount',
      align: 'center',
      columnProps: {
        label: '订单实付金额',
        prop: 'factAmount',
        minWidth: 150,
      },
    },

    {
      name: 'discountAmount',
      align: 'center',
      columnProps: {
        label: '优惠金额',
        prop: 'discountAmount',
        minWidth: 150,
      },
    },

    {
      name: 'usedAmount',
      align: 'center',
      columnProps: {
        label: '已核销金额',
        prop: 'usedAmount',
        minWidth: 150,
      },
    },

    {
      name: 'refundAmount',
      align: 'center',
      columnProps: {
        label: '已退款金额',
        prop: 'refundAmount',
        minWidth: 150,
      },
    },
  ]

  return {
    searchColumn,
    tableColumns,
  }
}
